
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';
import listRequest from '../../../js/listRequest.js';
import Schedule, {DateType, ScheduleDatasType, ScheduleDataItemType, CardStatus} from '@/components/Schedule/index.vue';
import EditScheduleDialog, {DateFormat} from '@/components/Schedule/EditScheduleDialog.vue';
import ScheduleSettingDialog from '@/components/Schedule/SettingDialog.vue';
// import CoursePlan from '@/components/Schedule/CoursePlan.vue';
import {WeekTexts} from '@/components/Schedule/utils';
import ScrollSelect from '@/components/ScrollSelect/index.vue';
import {
    getScheduleListApi,
    getUserFindApi,
    getAllClassListApi,
    getScheduleRoutineSettingApi,
    deleteScheduleApi,
    exportScheduleApi
} from '@/components/Schedule/api';
import {SectionToChinese, formatClasses, isSectionTimeDisabled, isSectionTimeNoBegin} from '@/components/Schedule//utils';
import moment, {Moment} from 'moment';
import {downloadFile} from '@/js/fileHelper';
interface ListDatasItemType extends ScheduleDataItemType {
    status: string;
    statusText: string;
    date: string;
}
@Component({
    components: {
        Schedule,
        EditScheduleDialog,
        ScheduleSettingDialog,
        ScrollSelect
        // CoursePlan
    }
})
export default class scheduleManage extends Vue {
    //===================================data区域begin
    CardStatus = CardStatus;
    allowOperation = true;
    columns: any = [
        {
            dataIndex: 'number',
            title: '序号',
            scopedSlots: {customRender: 'num'}
        },
        {
            dataIndex: 'className',
            title: '上课班级'
        },
        {
            dataIndex: 'teacherName',
            title: '上课老师'
        },
        {
            dataIndex: 'date',
            title: '上课时间'
        },
        {
            dataIndex: 'title',
            title: '上课内容',
            customRender: (text: string) => text || '-'
        },
        {
            dataIndex: 'remark',
            title: '备注',
            customRender: (text: string) => text || '-'
        },
        {
            dataIndex: 'statusText',
            title: '状态',
            scopedSlots: {customRender: 'status'}
        },
        {
            title: '操作',
            dataIndex: 'operation',
            scopedSlots: {customRender: 'operation'}
        }
    ];
    pager: {
        pagesize: number;
        pagenum: number;
        total: number;
        rows: ListDatasItemType[];
    } = {
        pagesize: listRequest.pagesize,
        pagenum: 1,
        total: 0,
        rows: []
    };
    form: {
        classId?: string;
        teacherId?: string;
        date?: Moment[];
    } = {
        classId: undefined,
        teacherId: undefined,
        date: undefined
    };
    scheduleDatas: ScheduleDatasType = [];

    uiType: 'card' | 'list' = 'card';
    showEditScheduleDialog = false;
    showScheduleSettingDialog = false;
    defaultScheduleData = {};
    loadingClass = false;
    loadingTeacher = false;
    classList: {label: string; value: string}[] = [];
    teacherList: {label: string; value: string}[] = [];
    schoolId = '';
    schoolName = '';
    settingData: {startTime: string | null; endTime: string | null}[] = [];
    cardDate = {
        startDate: '',
        endDate: ''
    };
    refreshTimer?: number;

    //===================================data区域end

    //===================================computed区域begin
    // 节数组：开始、结束时间
    get sections() {
        return this.settingData.map(({startTime, endTime}, index) => ({
            text: `第${SectionToChinese(index + 1)}节`,
            startTime,
            endTime
        }));
    }
    get hasSectionLen() {
        return this.settingData.length;
    }
    get exportDisabled() {
        return !this.hasSectionLen || (this.uiType === 'card' && !this.form.classId && !this.form.teacherId);
    }
    //===================================computed区域end
    created() {
        let value = window.localStorage.getItem('aicp_school_materials_$state_aicp_school_materials');
        this.schoolId = JSON.parse(value as string).schoolId;
        this.schoolName = JSON.parse(window.localStorage.getItem('schoolInfo') as string).name;
        this.getSettingList();
        this.init();
        this.refreshTimer = setInterval(() => {
            if (this.uiType === 'list') {
                this.refreshListStatus();
            } else if (this.$refs.Schedule) {
                (this.$refs.Schedule as Schedule).refreshData();
            }
        }, 60000);

        // this.showScheduleSettingDialog = true;
    }
    beforeDestroy() {
        clearInterval(this.refreshTimer);
    }

    //===================================methods区域begin

    init() {
        Promise.all([this.getClassList(), this.getTeacherList()]).then(ress => {
            this.getCardList();
        });
    }

    async handleExport() {
        const getDate = () => {
            if (this.uiType === 'list') {
                const [startMoment, endMoment] = this.form.date || [];
                return {
                    startDate: startMoment.format(DateFormat),
                    endDate: endMoment.format(DateFormat)
                };
            }
            return this.cardDate;
        };
        const {teacherId, classId} = this.form;
        const getFileName = () => {
            if (teacherId) {
                const teacherName = this.teacherList.find(x => x.value === teacherId)?.label;
                return `${this.schoolName}${teacherName}课程表.xlsx`;
            }
            if (classId) {
                const className = this.classList.find(x => x.value === classId)?.label;
                return `${this.schoolName}${className}课程表.xlsx`;
            }
            return `${this.schoolName}课程表.xlsx`;
        };

        const {startDate, endDate} = getDate();

        const params: any = {
            schoolId: this.schoolId,
            startDate,
            endDate
        };
        if (teacherId) {
            params.teacherId = teacherId;
        }
        if (classId) {
            params.classId = classId;
        }
        const fileName = getFileName();
        const blob = await exportScheduleApi(params, this.uiType);
        if (blob) {
            downloadFile(new Blob([blob]), fileName);
        }
    }

    changeClass(value: string) {
        this.form.classId = value;
        this.handleSearchList();
    }

    openSettingDialog() {
        this.showScheduleSettingDialog = true;
    }

    changeSetting() {
        this.handleSearchList();
    }
    handleEditScheduleClose() {
        this.defaultScheduleData = {};
        this.showEditScheduleDialog = false;
    }

    handleEditSchedule(item: any) {
        const {scheduledClassContent} = item;
        let courses: string[] = [];
        if (scheduledClassContent && scheduledClassContent.courseId && scheduledClassContent.cascadedNodes) {
            const [chapterItem, nodeItem] = scheduledClassContent.cascadedNodes;
            courses = [scheduledClassContent.courseId, chapterItem?.id, nodeItem?.id];
        }
        const classIndex = item.disabled ? undefined : item.classIndex;
        this.defaultScheduleData = {
            ...item,
            date: moment(item.scheduledDate, DateFormat),
            courses,
            classIndex
        };
        this.showEditScheduleDialog = true;
    }
    handleCreateSchedule(item?: {date: Moment; sectionIndex: number}) {
        if (!this.hasSectionLen) {
            return this.$confirm({
                title: '提示',
                content: '添加排课前需要进行节时间设置，请前往【课时设置】进行配置。',
                okText: '去设置',
                onOk: () => {
                    this.openSettingDialog();
                }
            });
        }
        if (item && item.date) {
            const {date, sectionIndex} = item;
            this.defaultScheduleData = {
                date,
                classIndex: sectionIndex
            };
        }
        this.showEditScheduleDialog = true;
    }
    handleEditScheduleOk() {
        this.getActiveList();
    }

    handleDelete(item: any) {
        this.$confirm({
            title: '提示',
            content: '确定要删除吗？',
            onOk: async () => {
                await deleteScheduleApi({id: item.id});
                this.getActiveList(this.pager.pagenum > Math.ceil((this.pager.total - 1) / this.pager.pagesize));
            }
        });
    }

    toggleUiType() {
        this.uiType = this.uiType === 'card' ? 'list' : 'card';
        if (this.uiType === 'list') {
            const {startDate, endDate} = this.cardDate;
            this.form.date = [moment(startDate, DateFormat), moment(endDate, DateFormat)];
        }
        this.getActiveList(true);
    }

    getActiveList(isReset = false) {
        if (this.uiType === 'list') {
            if (isReset) {
                this.pager.pagenum = 1;
                this.pager.rows = [];
            }
            return this.getList();
        } else if (this.uiType === 'card') {
            this.getCardList();
        }
    }

    async getList() {
        const datas = await this.getScheduleList();
        this.pager.rows = datas;
    }
    //模糊搜索
    handleSearchList() {
        this.getActiveList(true);
    }

    paginationChange(page: number, pageSize: number) {
        this.pager.pagenum = page;
        this.getList();
    }

    changeDate(date: DateType) {
        const {startDate, endDate} = date;
        this.cardDate = {
            startDate: startDate.replace(/\//g, '-'),
            endDate: endDate.replace(/\//g, '-')
        };
        if (this.loadingTeacher || this.loadingClass) return;
        this.getCardList();
    }

    async getCardList() {
        const datas = await this.getScheduleList();
        this.scheduleDatas = datas as ScheduleDatasType;
    }

    addToScheduleData(result: ScheduleDatasType, item: ScheduleDataItemType) {
        let {classIndex, scheduledDate, scheduledClassContent} = item;
        if (!(classIndex >= 0) || classIndex >= this.hasSectionLen) {
            classIndex = this.hasSectionLen;
            item.disabled = true;
        }
        const weekday = moment(scheduledDate, DateFormat).weekday();
        // const scheduleItem = this.formatScheduleData(item);
        const {name, title} = this.getCourseTitle(scheduledClassContent);
        const scheduleItem = {
            ...item,
            name,
            title
        };
        if (!result[weekday]) {
            result[weekday] = [];
        }
        if (!result[weekday][classIndex]) {
            result[weekday][classIndex] = [];
        }

        (result[weekday][classIndex] as any[]).push(scheduleItem);
    }
    refreshListStatus() {
        this.pager.rows = this.pager.rows.map(item => {
            const {status, statusText} = this.getListStatus(item);
            return {
                ...item,
                status,
                statusText
            };
        });
    }

    getListStatus(item: ScheduleDataItemType) {
        const {scheduledDate, classIndex} = item;
        const disabled = !(classIndex >= 0 && classIndex < this.hasSectionLen);
        const startTime = disabled ? '' : this.sections[classIndex].startTime;
        const endTime = disabled ? '' : this.sections[classIndex].endTime;
        const dateValue = moment(scheduledDate, DateFormat).valueOf();
        const todayValue = moment(moment().format(DateFormat), DateFormat).valueOf();
        let status = dateValue === todayValue ? CardStatus.active : dateValue < todayValue ? CardStatus.disabled : CardStatus.normal;
        let statusText = dateValue === todayValue ? '上课中' : dateValue < todayValue ? '已结束' : '待开始';
        // 兼容今天的状态
        if (dateValue === todayValue) {
            if (endTime && isSectionTimeDisabled(endTime)) {
                status = CardStatus.disabled;
                statusText = '已结束';
            } else if (startTime && isSectionTimeNoBegin(startTime)) {
                status = CardStatus.normal;
                statusText = '待开始';
            }
        }
        return {
            status,
            statusText
        };
    }

    getListDataFormat(item: ScheduleDataItemType) {
        const {scheduledDate, classIndex} = item;
        const dataMoment = moment(scheduledDate, DateFormat);
        const weekday = dataMoment.weekday();
        // const dateValue = dataMoment.valueOf();
        const {name, title} = this.getCourseTitle(item.scheduledClassContent);
        const disabled = !(classIndex >= 0 && classIndex < this.hasSectionLen);
        const startTime = disabled ? '' : this.sections[classIndex].startTime;
        // const endTime = disabled ? '' : this.sections[classIndex].endTime;
        const date = `${scheduledDate.replace(/-/g, '/')}（${WeekTexts[weekday]}）${startTime}`;
        const {status, statusText} = this.getListStatus(item);
        return {
            ...item,
            date,
            status,
            statusText,
            name,
            disabled,
            title
        };
    }

    getScheduleList(): Promise<any[]> {
        return new Promise(resolve => {
            const {teacherId, classId} = this.form;

            const urlParams: any = {
                schoolId: this.schoolId
            };
            if (teacherId) {
                urlParams.teacherId = teacherId;
            }
            if (classId) {
                urlParams.classId = classId;
            }
            if (this.uiType === 'card') {
                urlParams.startDate = this.cardDate.startDate;
                urlParams.endDate = this.cardDate.endDate;
            } else {
                const [startDate, endDate] = this.form.date || [];
                if (startDate && endDate) {
                    urlParams.startDate = startDate.format(DateFormat);
                    urlParams.endDate = endDate.format(DateFormat);
                }
                urlParams.pageSize = this.pager.pagesize;
                urlParams.skip = (this.pager.pagenum - 1) * this.pager.pagesize;
            }

            // urlParams.endDate = '2023-04-03';
            getScheduleListApi(urlParams).then(res => {
                if (res) {
                    const classes = res.data?.classes;
                    if (!(classes && classes.length)) {
                        return resolve([]);
                    }
                    if (this.uiType === 'card') {
                        const result: ScheduleDatasType = [];
                        classes.forEach((item: ScheduleDataItemType) => {
                            this.addToScheduleData(result, item);
                        });
                        return resolve(result);
                    }
                    if (this.uiType === 'list') {
                        let result: ListDatasItemType[] = [];
                        // const todayValue = moment('2023-05-01', DateFormat).valueOf();

                        classes.forEach((item: ScheduleDataItemType) => {
                            result.push(this.getListDataFormat(item));
                        });
                        this.pager.total = res.data.total;
                        return resolve(result);
                    }
                }
                resolve([]);
            });
        });
    }
    getCourseTitle(scheduledClassContent?: {courseName?: string; cascadedNodes?: {name: string}[]}) {
        let name = scheduledClassContent?.courseName || '';
        const nodeName = scheduledClassContent?.cascadedNodes?.length ? scheduledClassContent?.cascadedNodes[1].name : '';
        const title = name ? `《${name}》${nodeName}` : '';
        return {
            name,
            title
        };
    }

    async getSettingList() {
        const urlParams = {
            schoolId: this.schoolId
        };
        const res = await getScheduleRoutineSettingApi(urlParams);
        if (res) {
            this.settingData = formatClasses(res.data.classes);
            return;
        }
        this.settingData = [];
    }

    getClassList() {
        return new Promise(resolve => {
            let urlQueryParmas: any = {
                schoolId: this.schoolId,
                pagesize: 500
            };
            if (this.loadingClass) return;
            this.loadingClass = true;
            getAllClassListApi(urlQueryParmas, this).then(res => {
                if (res && res.data) {
                    this.classList = res.data.map((item: {_id: string; name: string}) => ({
                        value: item._id,
                        label: item.name
                    }));
                }
                this.loadingClass = false;
                resolve(res);
            });
        });
    }
    getTeacherList() {
        return new Promise(resolve => {
            let urlParams: any = {
                schoolId: this.schoolId,
                role: 'teacher'
            };
            if (this.loadingTeacher) return;
            this.loadingTeacher = true;
            getUserFindApi(urlParams, this).then((res: any) => {
                if (res && res.data) {
                    this.teacherList = res.data
                        .filter((item: {courseCount: number}) => item.courseCount > 0)
                        .map((item: {nickname: string; _id: string}) => ({
                            label: item.nickname,
                            value: item._id
                        }));
                    this.loadingTeacher = false;
                    return resolve(res);
                }
                this.loadingTeacher = true;
                resolve('失败');
            });
        });
    }

    //===================================methods区域end
}
